module.exports = __webpack_public_path__ + "img/account-circle.dc5af88c.svg";